import { useContext } from 'react';

import { CustomStylesCtx } from '@webapp/common/components/custom-styles';
import { setHtml } from '@webapp/common/lib/ui';

import { selectStatusMessage } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

export const StatusMessage: FC = () => {
    const {
        question: { text: questionTextStyles },
    } = useContext(CustomStylesCtx);
    const text = useStateSelector(selectStatusMessage);

    return <div data-testid='disabled-message' {...setHtml(text)} style={questionTextStyles} />;
};
